import { CustomerService2Fill } from '@datanomik/commons-ui/icons';

export const SupportIcon = () => <CustomerService2Fill />;
